import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { editAreaRequest } from '../requests/editAreaRequest';
import { AreaFormProps } from '../types/area.type';
import { Alert } from '../../../components/Alert';
import { queryClient } from '../../../app/App';
import { AxiosError } from 'axios';

export function useEditArea() {
	const navigate = useNavigate();

	const editArea = useMutation({
		mutationFn: async (data: AreaFormProps) => {
			return editAreaRequest(data);
		},
		onSuccess: () => {
			Alert({ message: 'Successfully edited!', type: 'success' });
			queryClient.invalidateQueries(['AREA_LIST']);
			navigate(-1);
		},
		onError: (error: AxiosError) => {
			Alert({ message: error.message, type: 'error' });
		},
	});

	return { editArea };
}
